<template>
  <v-app>
    <img src="./assets/legalhouseusa.svg" class="logo" />
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.logo {
  width: 300px;
  display: block;
  margin-bottom: 50px;
}
</style>
